import React from 'react';
import {Route} from 'react-router-dom';
import {useBothAuthService} from '../provider/AuthProvider';
import {AUTH_TYPE_COGNITO} from '../properties/auth';
import {pushPathChange} from '../utils/googleAnalyticsUtil';

const ProtectedRoute = ({component, ...otherProps}) => {
    const {authService, oktaAuthService} = useBothAuthService();
    const isCognito = otherProps.auth === AUTH_TYPE_COGNITO;
    const service = isCognito ? authService : oktaAuthService;

    const pagePath = isCognito
        ? (service.isAuthenticated() ? 'new' : 'NEW_SIGNIN')
        : (service.isAuthenticated() ? 'existing' : 'EXISTING_SIGNIN');
    const pageTitle = isCognito
        ? (service.isAuthenticated() ? 'new' : 'New_SignIn')
        : (service.isAuthenticated() ? 'existing' : 'Existing_SignIn');

    const renderHandler = (Component) => (props) => {
        pushPathChange('pageViewLoaded', pagePath, pageTitle);

        if (!!Component && service.isAuthenticated()) {
            return <Component {...props} />;
        } else {
            service.signinRedirect();
            return <span/>;
        }
    };
    return <Route {...otherProps} render={renderHandler(component)} />;
};

export default ProtectedRoute;